import {
  CompanyCreationDocument,
  CompanyCreationDocumentStatus,
} from '__generated__/GQL';

import { VerificationStatus } from '../../Verification/lib/steps/types';

export const getCompanyCreationDocumentsStatus = ({
  documents,
  isCompanyCreationSASU,
}: {
  documents: Pick<CompanyCreationDocument, 'id' | 'status'>[];
  isCompanyCreationSASU: boolean;
}): VerificationStatus => {
  if (!isCompanyCreationSASU) {
    return VerificationStatus.Irrelevant;
  }

  if (
    documents.some(
      (doc) => doc.status === CompanyCreationDocumentStatus.Refused,
    )
  ) {
    return VerificationStatus.Invalid;
  }

  if (
    documents.some(
      (doc) => doc.status === CompanyCreationDocumentStatus.Missing,
    )
  ) {
    return VerificationStatus.ToDo;
  }

  if (
    documents.every(
      (doc) => doc.status === CompanyCreationDocumentStatus.Validated,
    )
  ) {
    return VerificationStatus.Validated;
  }

  return VerificationStatus.Completed;
};
